import * as React from "react";
import type { SVGProps } from "react";
const SvgBriller3D = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 140.94 62.031"
    {...props}
  >
    <path
      d="M2286.04 372.763c-4.69-1.93-6.99-4.1-11.67-6.989-11.33-9.774-25.06-24.877-31.15-30.113-1.78.814-1.09 13.068-3.64 12.64-5.53-.671-4.85-24.983 3.72-23.939 6.06 1.579 21.16 9.271 33.02 14.6.24.108 5.03 2.164 9.72 3.952v29.847Zm27.08-38.86c3.38-.841 4.63-8.026 6.57-10.372 6.23 2.669 11.72 5.135 17.06 7.781l34.37-7.184c-4.13-.812-8.33-1.65-11.89-2.372-14.21-2.881-24.09-5.484-38.89-7.756-9.31.1-16.36 19.9-7.22 19.9Zm32.47 26.531c-2.13.406-3.06-3.176-3.31-4.562-.42-2.358-1.7-4.251-3.81-4.014-2.27.254-4.49 5.478-4.49 5.478s-2.7 6.511-4.61 7.589c-8.94 3.28-22.97 7.475-34.79 11.072-1.13.343-.71-3.206-5.41-1.646v-30.292l87.81-18.305-.8 23.031a7 7 0 0 0-2.29 1.014c-.96.924-.54 2.723-1.31 3.008 0 0-18.61 6.03-26.99 7.627m-18.12-9.652c.05-8-2.72-9.174-8.56-7.509-3.29.937-8.51 1.874-12.16 3.037-4.01 1.277-5.46 8.187-5.48 8.5-.41 6.852-1.64 15.232 7.01 12.712 2.78-.814 8.28-2.647 11.5-3.622 4.91-1.48 7.64-4.107 7.69-13.118m38.68-17.709a9 9 0 0 0-2.15.309c-2.64.655-6.04 1.172-10.2 2.274-3.89 1.034-4.66 8.094-4.67 8.344-.29 4.773-1.08 10.482 3.35 10.482a8 8 0 0 0 2.22-.365c2.22-.647 5.77-1.469 8.34-2.243 3.9-1.177 6.19-3.974 6.39-11.075.14-5.043-.18-7.726-3.28-7.726"
      data-name="Briller3D.svg"
      style={{
        fill: "currentColor",
        fillRule: "evenodd",
      }}
      transform="translate(-2236.03 -314)"
    />
  </svg>
);
export default SvgBriller3D;
